import { MedicationIcon } from './MedicationIcon';

/**
 * author: Google
 * id 57211BE3-0055-4D43-B05C-3CD0FE10322C
 * name medication
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medication.svg
 * tags
 * - Health / Beauty 
 * - Medical / Hospital 
 */
export const MedicineBottleIcon = MedicationIcon;
export default MedicineBottleIcon